import { useParams } from "react-router";
import { ProductLineCreate } from "./ProductLineCreate";
import { useGetOneProductLine } from "src/api/client-api/productLines/useGetOneProductLine";
import { useTranslation } from "react-i18next";

export const ProductLineEdit = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const { productLine, isFetched } = useGetOneProductLine({
        productLineId: id,
    });

    if (isFetched === false) {
        return;
    }

    if (productLine === undefined) {
        return <>{t("product_line.error", "Error loading product line")}</>;
    }

    return <ProductLineCreate productLine={productLine} />;
};
